import { Card, Col, Row, Typography } from "antd";
import React from "react";

const { Text } = Typography;

export default function DepositTransaction({ colors }) {
  const transactions = [
    {
      id: 1,
      dateTime: "20 March, 2025\n10:30 AM",
      paymentMethod: "assets/aya pay.png",
      status: "pending",
      amount: "+1000 MMK",
    },
    {
      id: 2,
      dateTime: "20 April, 2025\n10:40 AM",
      paymentMethod: "assets/kbz pay.png",
      status: "approved",
      amount: "+4000 MMK",
    },
    {
      id: 3,
      dateTime: "21 Feb, 2025\n02:15 PM",
      paymentMethod: "assets/wave pay.png",
      status: "rejected",
      amount: "-2000 MMK",
    },
    {
      id: 4,
      dateTime: "22 Jan, 2025\n09:45 AM",
      paymentMethod: "assets/cb pay.png",
      status: "pending",
      amount: "+2000 MMK",
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return colors.success;
      case "rejected":
        return colors.danger;
      case "pending":
        return colors.warning;
      default:
        return "black";
    }
  };
  return (
    <>
      <Row style={{ width: "100%" }}>
        <Col span={24}>
          <Row justify="space-between" align="middle" style={{ width: "100%" }}>
            <Col>
              <Text style={{ color: colors.secondary }} strong>
                Recent
              </Text>
            </Col>
            <Col>
              <Text style={{ color: colors.secondary, opacity: 0.8 }}>
                See all
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{width:"100%", padding:"0px 8px"}}>
        <Col span={24} style={{ marginTop: "10px" }}>
          {transactions.map((transaction) => (
            <Card
              styles={{ body: { padding: 0, margin: 0 } }}
              style={{
                padding: "16px 14px",
                margin: "10px 0px",
                borderRadius: "20px",
                backgroundColor: colors.background,
              }}
            >
              <Row gutter={[16, 0]} align="middle" justify="space-between">
                <Col>
                  {transaction.dateTime.split("\n").map((line, i) => (
                    <Text key={i} style={{ display: "block" }}>
                      {i === 0 ? line : <Text>{line}</Text>}
                    </Text>
                  ))}
                </Col>
                <Col>
                  <img
                    src={transaction.paymentMethod}
                    alt="payment"
                    style={{ width: 40, height: 40 }}
                  />
                </Col>
                <Col>
                  <Text style={{ color: getStatusColor(transaction.status) }}>
                    {transaction.status.charAt(0).toUpperCase() +
                      transaction.status.slice(1)}
                  </Text>
                </Col>
                <Col>
                  <Text style={{ color: getStatusColor(transaction.status) }}>
                    {transaction.amount}
                  </Text>
                </Col>
              </Row>
            </Card>
          ))}
        </Col>
      </Row>
    </>
  );
}
